import { Quotes, Star } from "@phosphor-icons/react";
import { Reveal, MaskLine, Parallax } from "@/lib/anim";

const TESTIMONIALS = [
  {
    quote:
      "They didn't hand us a template and call it custom. Mobyle built the exact CRM our sales team dreamed about — and it runs half our follow-ups on autopilot now.",
    name: "Jordan Reyes",
    role: "VP Sales, Northlane",
    img: "https://images.unsplash.com/photo-1758600587730-a11917c13b85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4NjM4MzYzNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "The blueprint stage sold me — features, timeline and price in writing before a dollar changed hands. Everything shipped on spec. No surprises.",
    name: "Amelia Chen",
    role: "Founder, Cadence Studio",
    img: "https://images.unsplash.com/photo-1764545973653-94c40d993495?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4NjM4MzYzNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "We own everything they built — no lock-in, no hostage fees. And the AI automations quietly save my team about ten hours a week.",
    name: "Marcus Bell",
    role: "COO, Bright Harbor",
    img: "https://images.unsplash.com/photo-1765776830139-72b2184dae5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4NjM4MzYzNXww&ixlib=rb-4.1.0&q=85",
  },
];

export const Testimonials = () => {
  return (
    <section
      className="relative py-28 md:py-40 bg-transparent"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Parallax speed={0.12} className="max-w-2xl mb-16">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-teal/80">
              Proof, not promises
            </span>
          </Reveal>
          <h2 className="mt-6 font-heading font-extrabold tracking-tighter text-white text-3xl sm:text-4xl md:text-5xl leading-[1.02]">
            <MaskLine>Engineered for one</MaskLine>
            <MaskLine delay={0.08}>thing: results.</MaskLine>
          </h2>
        </Parallax>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal
              key={t.name}
              delay={i}
              className="rounded-2xl border border-white/10 bg-[#0A0A0A] p-8 flex flex-col hover:border-teal/30 transition-colors duration-500"
            >
              <Quotes size={34} weight="fill" className="text-teal/70" />
              <div className="mt-4 flex gap-1">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={15} weight="fill" className="text-teal" />
                ))}
              </div>
              <p className="mt-5 text-white/80 leading-relaxed flex-1">
                "{t.quote}"
              </p>
              <div className="mt-8 flex items-center gap-4">
                <img
                  src={t.img}
                  alt={t.name}
                  className="h-12 w-12 rounded-full object-cover border border-white/10"
                />
                <div>
                  <div className="font-semibold text-white">{t.name}</div>
                  <div className="text-sm text-white/50">{t.role}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
